var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: ["selected-register-container", "lexon-view-container"] },
    [
      _c(_setup.LfHeaderTitleComponent, {
        staticClass: "mb-xxl",
        attrs: {
          title: _setup.title,
          buttons: _setup.buttons,
          executeAction: _setup.onExecuteAction,
        },
      }),
      _c(
        "div",
        { staticClass: "alerts-messages-container" },
        [
          _setup.tabs
            ? _c(_setup.TabsComponent, {
                staticClass: "tabs-other-styles",
                attrs: { tabs: _setup.tabs, context: _setup.context },
                on: { "changed-tab": _setup.onChangeTab },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }